// node modules
import _debounce from 'lodash/debounce';

// constants
import { DOCUMENT_ELEMENT } from '@/scripts/constants';

function windowResize() {
  const vw = window.innerWidth;
  let radius = vw * 0.19;
  if (window.matchMedia('(max-width: 1023px)').matches) {
    radius = vw * 0.3;
  }
  if (window.matchMedia('(max-width: 639px)').matches) {
    radius = vw * 0.5 - 15;
  }

  radius = Math.min(radius, 300);

  DOCUMENT_ELEMENT.style.setProperty('--radius', `${radius}px`);
}


windowResize();
window.addEventListener('resize', _debounce(windowResize, 100));
